export function getCurrencySymbol(locale: string, currency: string): string {
	return new Intl.NumberFormat(locale, { style: 'currency', currency })
		.formatToParts(99) // number doesn't matter here
		.filter(({ type }) => type === 'currency')[0]?.value;
}
